export const billingModeChanger = {
  ON_DEMAND: "On-Demand",
  STANDARD_EDITION: "Standard Edition",
  ENTERPRISE_EDITION: "Enterprise Edition",
  ENTERPRISE_PLUS_EDITION: "Enterprise Plus Edition",
};
